import './styles.scss';

const Button = ({
  label,
  color,
  styles,
  onClick = () => {},
  disabled = false
}) => {
    const disabledStyle = disabled ? { backgroundColor: 'gray', cursor: 'default' } : {};
    return (
    <button
      onClick={onClick}
      className='shared-button'
      style={ { ...styles , ...(color ? { backgroundColor: color , ...disabledStyle } : disabledStyle) } }
      disabled={disabled}
    >
      {label}
    </button>
  );
};

export default Button;
